import { Crate } from '@arcadiapower/shrike';
import styled from 'styled-components';
import { Wrapper } from '~/components/customer-details/customer-details.style';

export const StyledCrate = styled(Crate)`
  background-color: ${props => props.theme.colors.background.secondary};
  padding: 24px;
  border-radius: 8px;
`;

type GridProps = {
  backgroundColor?: string;
  marginBottom?: string;
  gridGap?: string | number;
  gridTemplateColumns?: string;
};

export const StyledTwoColumnGrid = styled(Wrapper)<GridProps>`
  display: grid;
  flex-grow: 1;
  justify-content: space-between;
  grid-template-columns: ${props => props.gridTemplateColumns || 'auto 32px'};
  grid-gap: ${props => props.gridGap || '24px'};
  border: none;
  margin-bottom: ${props => props.marginBottom || '24px'};
`;

export const ProofDocDisplayGrid = styled(Wrapper)`
  display: grid;
  flex-grow: 1;
  align-items: start;
  justify-content: space-between;
  grid-gap: ${props => props.gridGap || '24px'};
  grid-template-columns: 80px 3fr;
  border: none;
`;

export const StyledSeparator = styled.div`
  background-color: ${props => props.theme.colors.background.primary};
  margin: 16px 0;
`;

export const Spacer = styled.div`
  background-color: ${props => props.theme.colors.background.primary};
  margin: 24px 0;
`;

export const StyledLink = styled.a`
  display: inline-block;
  width: 80px;
  height: 80px;
  overflow: hidden;
  border: 1px;
  border-radius: 8px;
  target: _blank;
  rel: noopener noreferrer;
`;

type StyledDivProps = {
  url: string;
};
export const StyledDiv = styled.div<StyledDivProps>`
  width: 100%;
  height: 100%;
  background-image: url(${props => props.url});
  background-size: cover;
  background-position: center;
`;
